export const DEFAULT_ACTION = '@@cityoo-backoffice/DEFAULT_ACTION';
export const RESET_ALL = '@@cityoo-backoffice/RESET_ALL';
